import axios from '@/services/api';


export const getPosts = async ({ commit }, params ) => {

    const response = await axios.get('/posts', { params: params})

    const { data } = response;

    try {
        if (data) {
            commit('setPosts', data);
        }

    } catch (e) {
        console.log(e);
    }

};

export const getPostById = async ({ commit }, id) => {
    commit('setCurrentPost', null);
    const response = await axios.get(`/posts/${id}`)

    const { data } = response;

    try {
        if (data) {
            commit('setCurrentPost', data);
        }

    } catch (e) {
        console.log(e);
    }
}

export const add = async (_,payload) => {
    return await axios.post("posts", payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const edit = async (_, payload) => {

    return await axios.put("posts/" + payload['id'], payload)
        .then((response) => response)
        .catch((e) => e.response);
};

export const deletePost = async ({ commit }, id) => {

    await axios.delete(`/posts/${id}`)

    try {
        commit('setLoading', false);
    } catch (e) {
        console.log(e);
    }
};

